"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
class Domainer {
    constructor() {
        this.shutdown$ = new rxjs_1.Subject();
    }
    triggering(trigger$, manipulator, monad = operators_1.switchMap) {
        return trigger$.pipe(operators_1.takeUntil(this.shutdown$), operators_1.tap(t => Domainer.debug && console.debug("---- triggering", t)), monad(manipulator)).subscribe();
    }
    connecting(source, destination) {
        return source.pipe(operators_1.takeUntil(this.shutdown$), operators_1.tap(t => Domainer.debug && console.debug("---- connecting", t)), operators_1.tap((t) => destination.next(t))).subscribe();
    }
    updating(source, destination, isEqual = (a, b) => a === b) {
        return source.pipe(operators_1.takeUntil(this.shutdown$), operators_1.tap((t) => {
            if (!isEqual(destination.value, t)) {
                operators_1.tap(t => Domainer.debug && console.debug("---- updating", t)),
                    destination.next(t);
            }
        })).subscribe();
    }
}
exports.Domainer = Domainer;
Domainer.debug = false;
